/* Inert source template prevents the legacy TOC flashing before JS cleans it. */
if (!customElements.get('emp-quick-description')) {
  class EmpQuickDescription extends HTMLElement {
    connectedCallback(){this.boot=setTimeout(()=>this.render(),0);}
    render(){
      const source=this.querySelector('template'),target=this.querySelector('.emp-quick-description__text');
      if(!source||!target||this.ready)return;this.ready=true;
      const fragment=source.content.cloneNode(true);
      const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[:\s]+/g,'');
      fragment.querySelectorAll('h1,h2,h3,h4,h5,p').forEach(heading=>{
        if(heading.closest('li,blockquote')||!['tartalom','tartalomjegyzek'].includes(normalize(heading.textContent)))return;
        let node=heading.nextElementSibling,list=null;const spacers=[];
        for(let i=0;i<5&&node;i++){
          if(node.matches('ul,ol')){list=node;break;}
          if(node.matches('div,section')&&node.querySelector('ul,ol')){list=node;break;}
          if(node.matches('hr')||(node.matches('p')&&!node.textContent.trim())){spacers.push(node);node=node.nextElementSibling;}else break;
        }
        if(list)list.remove();
        const previous=heading.previousElementSibling;
        if(previous&&(previous.matches('hr')||/^[-_\u2013\u2014\s]{3,}$/.test(previous.textContent)))previous.remove();
        heading.remove();spacers.forEach(el=>el.remove());
      });
      fragment.querySelectorAll('script,style,img,video,iframe,table,hr').forEach(el=>el.remove());
      // Keep a concise rich-text excerpt; the full product page remains linked.
      const limit=650,text=fragment.textContent.trim();
      if(text.length>limit){
        const walker=document.createTreeWalker(fragment,NodeFilter.SHOW_TEXT);let node,total=0;
        while((node=walker.nextNode())){
          if(total+node.textContent.length>limit){
            let end=limit-total;const space=node.textContent.lastIndexOf(' ',end);if(space>Math.max(0,end-35))end=space;
            const range=document.createRange();range.selectNodeContents(fragment);range.setStart(node,end);range.deleteContents();fragment.append(document.createTextNode('\u2026'));break;
          }total+=node.textContent.length;
        }
      }
      target.replaceChildren(fragment);target.hidden=!target.textContent.trim();
    }
    disconnectedCallback(){clearTimeout(this.boot);}
  }
  customElements.define('emp-quick-description',EmpQuickDescription);
}
if(!window.EmpyreumQuickAccessibility){
  window.EmpyreumQuickAccessibility=true;
  document.addEventListener('keydown',event=>{
    if(event.target.matches?.('#Product-Drawer.emp-quick-modal .side-panel-close')&&(event.key==='Enter'||event.key===' ')){event.preventDefault();event.target.click();}
    const thumb=event.target.closest?.('#Product-Drawer.emp-quick-modal .product-thumbnail');
    if(thumb&&(event.key==='Enter'||event.key===' ')){event.preventDefault();thumb.click();}
  });
  document.addEventListener('quick-view:open',()=>{
    const modal=document.querySelector('#Product-Drawer.emp-quick-modal');if(!modal)return;
    modal.querySelector('.side-panel-inner').scrollTop=0;
    const title=modal.querySelector('.product-title');if(title)modal.setAttribute('aria-label',title.textContent.trim());
    modal.querySelectorAll('.product-thumbnail').forEach((t,i)=>{t.tabIndex=0;t.setAttribute('role','button');t.setAttribute('aria-label','Term\u00e9kk\u00e9p '+(i+1));});
    modal.querySelectorAll('emp-quick-description').forEach(el=>el.render?.());
  });
}
